import type { StudySessionCard } from "@/components/Flashcards/StudySession"

const KEY = "flashcard_active_session"
const TTL_MS = 24 * 60 * 60 * 1000

export type StudySessionMode = "due" | "subject" | "deck" | "custom"

export type StudySessionSnapshot = {
  mode: StudySessionMode
  params: {
    subjectId?: string
    subjectIds?: string[]
    deckId?: string
    deckIds?: string[]
    ratings?: number[]
    includeNew?: boolean
    shuffle?: boolean
  }
  cards: StudySessionCard[]
  index: number
  xpEarned: number
  streak: number
  savedAt: number
}

export function saveStudySession(snap: StudySessionSnapshot): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(snap))
  } catch {
    // storage full or unavailable — resume is best-effort
  }
}

export function loadStudySession(): StudySessionSnapshot | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const snap = JSON.parse(raw) as StudySessionSnapshot
    if (Date.now() - snap.savedAt > TTL_MS) {
      localStorage.removeItem(KEY)
      return null
    }
    return snap
  } catch {
    return null
  }
}

export function clearStudySession(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
